<template>
  <div class="container">
    <div v-show="loader" class="progress progress-xl">
      <div
        class="progress-bar progress-xl progress-bar-striped progress-bar-animated"
        role="progressbar"
        aria-valuenow="100"
        aria-valuemin="0"
        aria-valuemax="100"
        style="width: 100%;"
      >
        <h4 class="mt-2">Your changes are being saved ... please wait ...</h4>
      </div>
    </div>
    <br />
    <div
      v-show="message.state"
      class="alert alert-dismissible border-0 fade show"
      :class="message.type"
      role="alert"
    >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>{{ message.msg }}</strong>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title">Profile Settings</h2>
            <h6 v-show="first_login">Complete your profile</h6>
            <hr />
            <br />
            <form>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <div class="form-row">
                    <div class="form-group">
                      <h4 class="text-muted">
                        Formats: png,jpg. Max size: 1MB
                      </h4>
                      <div class="col-md-12 mt-4">
                        <div
                          style="width: 200px; height:200px;"
                          class="img-fluid"
                        >
                          <img
                            v-if="avatar_preview"
                            class="rounded-circle img-fluid"
                            :src="avatar_preview"
                            alt
                            style="width: 200px; height: 200px;"
                          />
                          <img
                            v-else-if="profilePhoto"
                            class="rounded-circle img-fluid"
                            :src="profilePhoto"
                            alt
                            style="width: 200px; height: 200px;"
                          />
                          <img
                            v-else
                            class="img-thumbnail img-fluid rounded rounded-circle"
                            src="../../../public/avatars/avatar-default.jpg"
                            alt
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div
                        class="col-md-12"
                        style="margin: auto; margin-top: auto; left: 20px; right: 0;"
                      >
                        <input
                          id="img_profile"
                          ref="file-input"
                          type="file"
                          accept="image/*"
                          style="display: none;"
                          @change="previsualizeAvatar($event)"
                        />

                        <label
                          class="text-center mt-4 mr-3 btn btn-outline-primary btn-rounded"
                          for="img_profile"
                          >Choose a profile photo</label
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label>Full Name</label>
                      <input
                        v-model="complete_name"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label>ID</label>
                      <input
                        v-model="id_number"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label>Which country does your ID belong to</label>
                      <v-select
                        v-model="selected_country_ID"
                        :options="country_list"
                      ></v-select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-sm-6">
                  <label>Company Type</label>
                  <v-select
                    v-model="selected_businessName"
                    :options="['Natural', 'Legal']"
                  ></v-select>
                </div>

                <div class="form-group col-sm-6">
                  <label>Mobile</label>
                  <input
                    v-model="phone_number"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="col col-sm-6">
                  <div class="form-group">
                    <label>Country of Residence</label>
                    <v-select
                      v-model="selected_country_resident"
                      :options="country_list"
                    ></v-select>
                  </div>
                </div>

                <div class="form-group col-sm-6">
                  <label>Address</label>
                  <textarea
                    v-model="address"
                    class="form-control"
                    rows="3"
                  ></textarea>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-sm-6 col-md-5">
                  <label>Ethereum Wallet (REQUIRED)</label>
                  <input
                    id="readonly"
                    v-model="EthereumWallet"
                    type="text"
                    class="form-control text-center account_text"
                    disabled
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="col col-sm-2 col-md-2"
                    @click="getWallet"
                >
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-rounded wallet_btn"
                  >
                    Connect to Metamask
                  </button>
                  <img src="../../assets/img/metamask-fox-wordmark-horizontal.svg" alt="Metamask Brand">
                </div>
              </div>
              <div class="text-right mt-4">
                <button
                  type="button"
                  class="btn btn-outline-success btn-rounded"
                  @click="complete_register"
                >
                  <i class="fas fa-check"></i>
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MetaMaskOnboarding from '@metamask/onboarding';

import {baseApiURL} from '../../configs'
const onboarding = new MetaMaskOnboarding();
const ethereum = window.ethereum;

export default {
  name: 'Profile',
  components: {},
  data() {
    return {
      message: {
        state: false,
        msg: '',
        type: '',
      },
      user_object: '',
      valid: false,
      id_number: '',
      email: '',
      complete_name: '',
      phone_number: '',
      address: '',
      selected_country_ID: '',
      selected_country_resident: '',
      selected_businessName: '',
      country_list: [],
      countries: [],
      country_resident_alpha2: '',
      country_ID_alpha2: '',
      first_login: false,
      avatar_preview: '',
      avatar_file: null,
      profilePhoto: '',
      loader: false,
      EthereumWallet: '',
    };
  },
  created() {
    this.load_countries();
    this.loadUserFromLocalstorage();
  },
  methods: {
    complete_register() {
      this.message.state = false;
      this.getCodeAlpha2(this.selected_country_resident, 'residence');
      this.getCodeAlpha2(this.selected_country_ID, 'id');
      if (!this.emptyFields()) {
        this.$http
          .put(`/user/Register`, {
            email: this.email,
            country: this.country_resident_alpha2,
            countryId: this.country_ID_alpha2,
            address: this.address,
            name: this.complete_name,
            businessName: this.selected_businessName,
            phoneNumber: this.phone_number,
            userIdentification: this.id_number,
            EthereumWallet: this.EthereumWallet,
          })
          .then(resp => {
            // get the user from the back response and store it in localStorage
            this.setUserInLocalstorage(resp);

            if (this.avatar_file) {
              console.log('ecntra');
              console.log(this.avatar_file);
              this.sendImg(this.avatar_file, resp.data.user);
            }

            this.message.type = 'alert-success';
            this.message.msg = 'Profile successfully updated';
            this.message.state = true;
            this.scrollNavigator();
            // wait 2 seconds before redirect
            setTimeout(() => {
              window.location = '/dashboard';
            }, 2000);
          })
          .catch(err => {
            this.message.msg = err.response.data.message;
            this.message.type = 'alert-warning';
            this.message.state = true;
            this.scrollNavigator();
          });
      } else {
        this.message.type = 'alert-warning';
        this.message.msg = 'One or more fields remain to be completed';
        this.message.state = true;
      }
      this.scrollNavigator();
    },
    emptyFields() {
      return (
        this.id_number === '' ||
        this.complete_name === '' ||
        this.phone_number === '' ||
        this.address === '' ||
        this.selected_country === '' ||
        this.selected_businessName === ''
      );
    },
    load_countries() {
      this.countries = require('./countries.json');
      for (let i = 0; i < this.countries.length; i++) {
        this.country_list.push(this.countries[i].name);
      }
    },
    loadUserFromLocalstorage() {
      this.user_object = JSON.parse(localStorage.getItem('user'));
      this.email = this.user_object.email;
      /* if the userId is in localstorage, it means that it is not the first
      time that the user enters the platform, that is, the user will update
      their data, otherwise, they are registering */
      if (this.user_object.userId) {
        this.id_number = this.user_object.userIdentification;
        this.complete_name = this.user_object.name;
        this.phone_number = this.user_object.phoneNumber;
        this.address = this.user_object.address;
        this.EthereumWallet = this.user_object.walletETH;
        if (this.user_object.avatar)
          this.profilePhoto = this.user_object.avatar;
        this.selected_businessName = this.user_object.businessName;
        this.selected_country_resident = this.getCountryNameByAlpha2(
          this.user_object.country
        );
        this.selected_country_ID = this.getCountryNameByAlpha2(
          this.user_object.countryId
        );
      } else {
        this.first_login = true;
      }
    },
    getCodeAlpha2(full_country, param) {
      /* the Alpha2 code is obtained from the name of the country
       that the user selects when completing the registration
       because the backend expects only the Alpha2 code */
      for (let i = 0; i < this.countries.length; i++) {
        if (this.countries[i].name === full_country) {
          if (param === 'residence')
            this.country_resident_alpha2 = this.countries[i].alpha2;
          else this.country_ID_alpha2 = this.countries[i].alpha2;
        }
      }
    },
    getCountryNameByAlpha2(userAlpha2) {
      /* when updating, you need to introduce the user
       your country in string format, like the data that comes from the backend
       is the Alpha2 code, the user's country name is obtained
       from the code Alpha2 */
      for (let i = 0; i < this.countries.length; i++) {
        if (this.countries[i].alpha2 === userAlpha2) {
          return this.countries[i].name;
        }
      }
    },
    setUserInLocalstorage(resp) {
      console.log(resp);
      this.user_object = resp.data.user;
      if (!this.user_object.avatar)
        this.user_object.avatar = `${baseApiURL}/api/user/file/GetPhoto?userId=${this.user_object.userId}`;
      localStorage.setItem('user', JSON.stringify(this.user_object));
      this.$store.state.user = this.user_object;
    },
    scrollNavigator() {
      // scroll to the top of the browser
      // so that the user can view the alert
      window.scroll({
        top: -5000,
        behavior: 'smooth',
      });
    },
    previsualizeAvatar(event) {
      const input = event.target;
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        let jsthis = this;
        // eslint-disable-next-line no-unused-vars
        reader.onload = e => {
          this.avatar_preview = e.target.result;
          jsthis.avatar_file = input.files[0];
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
      //this.sendImg();
    },
    sendImg(filesito, userObject) {
      //let base = 'http://localhost:3000/api/user';
      // ${base}/uploadProfilePhoto?email=oliveiragabr@outlook.com
      // /user/uploadProfilePhoto?email=${this.$store.state.user.email}`
      this.loader = true;
      let formData = new FormData();
      formData.append('avatar', filesito);
      this.$http
        .post(
          `/user/uploadProfilePhoto?email=${encodeURI(
            this.$store.state.user.email
          )}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        .then(resp => {
          this.loader = false;
          /* Update Localstorage*/
          this.user_object = JSON.parse(localStorage.getItem('user'));
          this.user_object.avatar = `${baseApiURL}/api/user/file/GetPhoto?userId=${userObject.userId}`;
          localStorage.setItem('user', JSON.stringify(this.user_object));
          this.$store.state.user = this.user_object;

          this.message.type = 'alert-success';
          this.message.msg = resp.data.message;
          this.message.state = true;
          this.scrollNavigator();
          setTimeout(() => {
            window.location = '/dashboard';
          }, 2000);
          return true;
        })
        .catch(err => {
          console.log(err);
          this.loader = false;
          this.message.type = 'alert-warning';
          this.message.msg = err.response.data.message;
          this.message.state = true;
          this.scrollNavigator();
          return false;
        });
    },
    async getWallet() {
      if (MetaMaskOnboarding.isMetaMaskInstalled()) {
        const accounts = await ethereum.request({
          method: 'eth_requestAccounts',
        });
        this.EthereumWallet = accounts[0];
      } else {
        onboarding.startOnboarding();
      }
    },
  },
};
</script>

<style scoped>
.account_text {
  font-size: 14px;
}

.wallet_btn {
  margin-top: 2rem;
  font-size: 14px;
}
</style>
